/*
 * File: InputTextArea.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Formatting for text area input element
 */
import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import { observer } from "mobx-react";
import FilledInput from "@material-ui/core/FilledInput";

const InputTextArea = ({
  field,
  value,
  error,
  parentOnChange,
  parentOnBlur
}) => {
  return (
    <TextField
      onBlur={parentOnBlur}
      multiline={true}
      error={error}
      onChange={parentOnChange}
      fullWidth
      placeholder={field.placeholder}
      id={field.name}
      name={field.name}
      rows={field.rows || 4}
      rowsMax={11}
      defaultValue={value}
      InputProps={field.materialInputProps}
      variant="filled"
      input={<FilledInput name={field.label} id={field.label} />}
      label={field.label}
      disabled={field.disabled}
    />
  );
};

InputTextArea.propTypes = {
  field: PropTypes.object.isRequired,
  value: PropTypes.string,
  error: PropTypes.bool,
  parentOnChange: PropTypes.func.isRequired,
  parentOnBlur: PropTypes.func.isRequired
};

export default observer(InputTextArea);
